import React, { useEffect, useState } from "react";
import { Pagination } from "antd";
import { Icon } from "@iconify/react";
import close_btn from "../../../assets/images/close_btn.png";
import { FaTrash } from "react-icons/fa";
import axios from "axios";
import { useParams } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";
import { toast } from "react-toastify";

const AnalyzedProduct = (props) => {
  const { heading, hide, apiResponse, setSearch, setError } = props;
  const [current, setCurrent] = useState(1);
  const [history, setHistory] = useState([]);
  const { id } = useParams();
  const [deleteFile, setDeleteFile] = useState(false);
  const handleCloseModal1 = () => setDeleteFile(false);
  const handleShowModal1 = () => setDeleteFile(true);
//
  useEffect(() => {
    handleSaveHistory();
  }, [apiResponse]);

  const handleSaveHistory = async () => {
    try {
      axios
        .post("https://aipricingtool-python.onrender.com/get_saved_products", {
          user_identifier: id,
        })
        .then((response) => {
          setHistory(response.data);
          console.log(response.data);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const handleDeleteHistory = () => {
    handleCloseModal1();
    axios
      .post("https://aipricingtool-python.onrender.com/delete_history", {
        user_identifier: id,
      })
      .then((res) => {
        console.log(res.data);
        toast.success(res.data.message);
        setHistory([]);
      })
      .catch((err) => {
        console.log(err.response.data.error);
        toast.error(err.response.data.error);
      });
  };
  const onChange = (page) => {
    console.log(page);
    setCurrent(page);
  };

  const handleDeleteSelectedHistory = (product) => {
    console.log("product", product, id);
    axios
      .delete(
        "https://aipricingtool-python.onrender.com/delete_product_from_history",
        {
          data: {
            user_identifier: id,
            product_name: product,
          },
        }
      )
      .then((res) => {
        console.log(res.data);
        toast.success(res.data.success);
        handleSaveHistory();
      })
      .catch((err) => {
        console.log(err.data);
        toast.error("Failed to delete!");
      });
  };

  return (
    <>
      <div className="flex flex-col items-center w-100 mb-4">
        <span className=" text-xl md:text-3xl mb-2 font-semibold mr-5 primary text-center">
          {heading}
        </span>
        <div className="setting pagination pt-1 px-3 flex flex-col   w-full">
          <div className="pb-4 flex justify-end">
            <button
              className={`p-2 text-white rounded-lg  Campton w-auto`}
              style={{
                background:
                  "linear-gradient(102deg, #D73E3E 20.86%, #6B2B4B 120.36%)",
              }}
              onClick={handleShowModal1}
            >
              Clear All History
            </button>
          </div>
          <div>
            {history !== "" ? (
              <>
                {history?.map((result, index) => {
                  console.log(history);
                  return (
                    <div className="flex justify-between">
                      <div
                        key={index}
                        onClick={() => {
                          setError("");
                          setSearch(result);
                        }}
                        className="flex space-x-2 cursor-pointer w-4/5 "
                      >
                        <div className="flex items-center">
                          <Icon icon="lucide:file" width={20} height={20} />
                        </div>
                        <div
                          className={`overflow-x-hidden w-5/6 ${
                            result.length > 14 ? "truncate" : ""
                          }`}
                        >
                          {result}
                        </div>
                      </div>
                      <div
                        onClick={() => handleDeleteSelectedHistory(result)}
                        className="px-4 cursor-pointer"
                      >
                        <FaTrash size={15} />
                      </div>
                    </div>
                  );
                })}
              </>
            ) : (
              <div className="flex justify-center items-center h-24 text-xl font-bold primary">
                No History Yet
              </div>
            )}
          </div>
          <div className={`flex items-center w-100 justify-center ${hide}`}>
            <Pagination current={current} onChange={onChange} total={50} />
          </div>
        </div>
      </div>

      <Modal
        className="removeModal-1"
        onHide={handleCloseModal1}
        centered={true}
        show={deleteFile}
      >
        <div className="px-4 py-4">
          <div className="close_btn  d-flex justify-end mb-5">
            <img
              src={close_btn}
              alt=""
              onClick={handleCloseModal1}
              className="cursor-pointer"
            />
          </div>
          <div className="header-1 d-flex flex-column jutsify-center align-center gap-y-12">
            <Modal.Title className="text-center w-5/6">
              Are you Sure You Want To Permanently Delete The History and Data
              against it?
            </Modal.Title>
            <div className="d-flex gap-3 jutsify-center align-center m-auto mb-5">
              <Button
                className="btn-2 text-black Campton w-[101px]"
                onClick={() => {
                  handleDeleteHistory();
                }}
                style={{
                  border: "1px solid var(--Menu-Buttons-Grad, #D76E3E)",
                  background: "transparent",
                }}
              >
                Yes
              </Button>
              <Button
                className="btn-1 w-[101px]"
                onClick={handleCloseModal1}
                style={{
                  background:
                    "linear-gradient(102deg, #D73E3E 20.86%, #6B2B4B 120.36%)",
                  border: "none",
                }}
              >
                No
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default AnalyzedProduct;
